import { render, staticRenderFns } from "./electronic-detail.vue?vue&type=template&id=4d726f42"
import script from "./electronic-detail.vue?vue&type=script&lang=js"
export * from "./electronic-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports